export default __webpack_public_path__ + "static/a_data_politique_we_do_data-616b5c60dc7a4b8f5660e6da3223afdf.jpg";